"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * Renders either a horizontal or vertical line based on what index of data is
 * focused and the layout of the chart.
 */
var LineMarker = function LineMarker(_ref) {
  var anchorX = _ref.anchorX,
    anchorY = _ref.anchorY,
    isAnchoredX = _ref.isAnchoredX,
    isAnchoredY = _ref.isAnchoredY,
    plotHeight = _ref.plotHeight,
    plotWidth = _ref.plotWidth;
  if (isAnchoredX === isAnchoredY) {
    throw new Error("LineMarker must have either isAnchoredX or isAnchoredY set\n      to true, but not both. The rendering logic assumes that they will always\n      be exclusive.");
  }
  return /*#__PURE__*/_react["default"].createElement("line", {
    x1: isAnchoredX ? anchorX : 0,
    y1: isAnchoredY ? anchorY : 0,
    x2: isAnchoredX ? anchorX : plotWidth,
    y2: isAnchoredY ? anchorY : plotHeight,
    strokeWidth: 1,
    stroke: "grey"
  });
};
var _default = exports["default"] = LineMarker;
//# sourceMappingURL=LineMarker.js.map